// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  POST_HAZARD_SETTINGS,
  POST_HAZARD_SETTINGS_ERROR,
  POST_HAZARD_SETTINGS_SUCCESS,
} from "../../constants";
import axios from "../../../../services/api";
import { error as err, success } from "../../../../main";
function* postHazardsSettings(data) {
  const params = new URLSearchParams();

  if (data.hazards) {
    params.append("data", data.hazards);
  }

  try {
    const response = yield call(axios.post, `/settings/`, params);
    if (response.data.error) {
      yield put({
        type: POST_HAZARD_SETTINGS_ERROR,
        data: response.error,
      });
    } else {
      yield put({
        type: POST_HAZARD_SETTINGS_SUCCESS,
        data: response?.data,
      });
      yield call(success, `Hazard settings succeffully updated. `);
      data.callBack();
    }
  } catch (error) {
    yield put({
      type: POST_HAZARD_SETTINGS_ERROR,
      data: error,
    });
  }
}

export default function* postHazardsSettingsSaga() {
  yield takeLatest(POST_HAZARD_SETTINGS, postHazardsSettings);
}
